import { i18n } from "../i18n.js";

const makeQueryFromObject = data => {
  var query = "";
  for (var key in data) {
    if (data[key]) {
      query += key + "=" + data[key] + "&";
    }
  }
  return query.trim("&");
};
const getMediaUrl = (path, baseUrl) => {
  if (path.match(/^(#|\/\/|https?:\/\/|(mailto|tel|sms):)/gm)) {
    return path;
  }
  return baseUrl.rtrim("/") + "/" + path.ltrim("/");
};

const validateInput = (value, label, min = null, max = null) => {
  value = value.replace(",", ".");
  if (value == "") {
    return { valid: false, msg: i18n.t("Please input " + label + "!") };
  }
  if (isNaN(value)) {
    return { valid: false, msg: i18n.t(label + " must be a number!") };
  }
  if (min && parseFloat(value) < min) {
    return {
      valid: false,
      msg: i18n.t(label + " must be greater than {min}", { min })
    };
  }
  if (max && parseFloat(value) > max) {
    return {
      valid: false,
      msg: i18n.t(label + " must be smaller than {max}", { max })
    };
  }
  return { valid: true, msg: "", number: parseFloat(value) };
};

const computeCustomFormatLabel = (system, width, height) => {
  if (system == "imperial") {
    return (
      i18n.t("Custom Format") + " (" + width + '"' + " x " + height + '"' + ")"
    );
  } else {
    return (
      i18n.t("Custom Format") + " (" + width + " x " + height + " " + "cm" + ")"
    );
  }
};

export {
  makeQueryFromObject,
  validateInput,
  getMediaUrl,
  computeCustomFormatLabel
};
